import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const HeadingSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background-color: ${COLORS.bgWhite};
`

export const HeadingDate = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -0.3px;
  color: ${COLORS.textPrimary};
`
